import LifetimeBenefitsSection from './lifetime-benefits-section';

export default LifetimeBenefitsSection;
